/* The seeded RNG, carried over from acrostic-v1-app/app/js/seed.js unchanged.
 *
 * `mulberry32(20260706)` is load-bearing: a rebuild must deal the SAME gym, at every
 * size, or the demo stops being a place you can point at ("look at Paige Clark") and the
 * tests stop being able to assert anything about a particular person. Do not replace it
 * with Math.random, and do not change the seed. */
export function mulberry32(a) {
    return function () {
        a |= 0;
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
export const SEED = 20260706;
/** The draw helpers, in one object so a pass can be handed the deal rather than a global. */
export class Deal {
    rnd;
    constructor(rnd) {
        this.rnd = rnd;
    }
    static fresh(seed = SEED) {
        return new Deal(mulberry32(seed));
    }
    next() {
        return this.rnd();
    }
    /** A member of `arr`. Never called on an empty array; see pickOr for the guarded form. */
    pick(arr) {
        const v = arr[Math.floor(this.rnd() * arr.length)];
        if (v === undefined)
            throw new Error('Deal.pick on an empty pool');
        return v;
    }
    /** A member of `arr`, or `fallback` when the pool is empty. */
    pickOr(arr, fallback) {
        if (!arr.length)
            return fallback;
        return this.pick(arr);
    }
    /** Inclusive integer. */
    ri(a, b) {
        return a + Math.floor(this.rnd() * (b - a + 1));
    }
    rf(a, b) {
        return a + this.rnd() * (b - a);
    }
    chance(p) {
        return this.rnd() < p;
    }
    /** `n` distinct-ish draws joined with ';' — the multi-select answers the intake forms store. */
    someOf(arr, lo, hi) {
        const n = this.ri(lo, hi);
        const out = [];
        for (let k = 0; k < n; k++) {
            const v = this.pick(arr);
            if (!out.includes(v))
                out.push(v);
        }
        return out.join(';');
    }
    /** Weighted draw over [value, weight] pairs. */
    weighted(pairs, fallback) {
        const r = this.rnd();
        let acc = 0;
        for (const [v, w] of pairs) {
            acc += w;
            if (r <= acc)
                return v;
        }
        return fallback;
    }
}
